export default async function(file) {
  // FileReader.readAsArrayBuffer()
  // Starts reading the contents of the specified Blob, once finished, the result attribute contains an ArrayBuffer representing the file's data.

  // The ArrayBuffer object is used to represent a generic, fixed-length raw binary data buffer.
  // It is an array of bytes, often referred to in other languages as a "byte array"
  // You cannot directly manipulate the contents of an ArrayBuffer;
  // instead, you create one of the typed array objects or a DataView object which represents the buffer in a specific format, and use that to read and write the contents of the buffer.

  return new Promise((resolve, reject) => {
    let reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result);
    };

    reader.onerror = () => {
      alert('error writing file');
      reject();
    };

    reader.readAsArrayBuffer(file);
  });
}
